import { ZoomOption } from "./page.vm";

// TODO MAKE MORE ROBUST (view archive structure should have scroll always in the same site)
export const getParentPageElement = target => {
  var _target$closest;
  return (_target$closest = target.closest('.archive-modal-body-scrollable')) !== null && _target$closest !== void 0 ? _target$closest : target.closest('.viewer-archive-document-container');
};
export const pageRelativeDim = (pageDim, rotation) => {
  const {
    originalHeight,
    originalWidth
  } = pageDim;
  const pageWidth = rotation === 0 || rotation === 180 ? originalWidth : originalHeight;
  const pageHeight = rotation === 0 || rotation === 180 ? originalHeight : originalWidth;
  return {
    pageWidth,
    pageHeight
  };
};
export const pageZoomScale = (zoom, pageDim, layoutDim, rotation) => {
  if (typeof zoom === 'number') {
    return zoom;
  } else {
    const {
      width,
      height
    } = layoutDim;
    const {
      pageWidth,
      pageHeight
    } = pageRelativeDim(pageDim, rotation);
    if (zoom === ZoomOption.Z_WINDOW_WIDTH) {
      const autofit = width / pageWidth;
      return autofit;
    } else if (zoom === ZoomOption.Z_WINDOW_SIZE) {
      const autofitWidth = width / pageWidth;
      const autofitHeight = height / pageHeight;
      const autofit = Math.min(autofitWidth, autofitHeight);
      return autofit;
    }
    return 1;
  }
};
export const pageThresholdRatio = 0.7;
export const getChangePageThreshold = (layoutDim, scale, rotation, dims) => {
  if (!dims) return pageThresholdRatio;
  let fitThresholdRatio = pageThresholdRatio;
  const viewport = layoutDim;
  const relativeDims = pageRelativeDim(dims, rotation);
  const currentDims = {
    height: relativeDims.pageHeight * scale,
    width: relativeDims.pageWidth * scale
  };
  const heightGreatterThanViewport = currentDims.height > viewport.height;
  const widthGreatterThanViewport = currentDims.width > viewport.width;
  if (heightGreatterThanViewport && widthGreatterThanViewport) {
    const viewportAreaToFill = viewport.height * viewport.width * pageThresholdRatio;
    const currentArea = currentDims.height * currentDims.width;
    fitThresholdRatio = viewportAreaToFill / currentArea;
  } else if (heightGreatterThanViewport) {
    fitThresholdRatio = viewport.height * pageThresholdRatio / currentDims.height;
  } else if (widthGreatterThanViewport) {
    fitThresholdRatio = viewport.width * pageThresholdRatio / currentDims.width;
  }
  return fitThresholdRatio;
};